/* eslint-disable react-hooks/exhaustive-deps */
import Accordion from 'SpendController/Components/Accordian/Accordian';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	Header,
	HeaderSpan,
	InnerContainer,
	RefreshSpan,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	WORKSHOP_KPI_DATA,
	combineDataWorkShopKpiData,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import { getWorkshopSummaryKpis } from 'utils/apiRequests';

function WorkShop() {
	const [workShopBaselineKpiData, setWorkShopBaselineKpiData] = useState(
		WORKSHOP_KPI_DATA
	);
	const [isLoading, setIsLoading] = useState(false);
	const selectedSpendType = ['MACRO'];
	const {
		filters,
		workShopColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MACRO'];
		realTime && setIsLoading(true);
		const workShopBaselineKpiDataResponse = await getWorkshopSummaryKpis(
			microFilters
		);

		const tempPreWorkShopBaselineKpiData = combineDataWorkShopKpiData(
			workShopBaselineKpiDataResponse,
			workShopBaselineKpiData.data
		);
		setWorkShopBaselineKpiData({
			...workShopBaselineKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<BreakDownFilters />
			<InnerContainer>
				<Accordion name={`WorkShop Health Bar`} idkey={'acc1'}>
					<Summary {...workShopBaselineKpiData} />
				</Accordion>
			</InnerContainer>
			<ColumnContainer>
				<Header>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableWrapper n={6}>
					<TableView
						data={workShopColumnDefs}
						columnDefs={workShopColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default WorkShop;
